import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row } from "reactstrap";
import { connect } from "react-redux";


// services
import { typeRestrictionService } from '../../../jwt/_services/todoFluye/typeRestrictionService'


const RestaurantPaxDetails = props => {
    const {
        maxSize,
        setExternalData = d => console.warn('default function',d)
    } = props

    const [ loadingPax, setLoadingPax] = useState( false )
    const [ paxOption, setPaxOption ] = useState( [] )
    const [ paxDetails, setPaxDetails ] = useState( [] )



    // load options
    useEffect( () => {
        setLoadingPax( true )

        typeRestrictionService.all()
            .then( result => {
                if(!result)
                    return

                setPaxOption( result )
            })
            .catch( console.log )
            .finally( () => setLoadingPax( false ) )
    }, [] )


    //formed pax details
    useEffect( () => {
        if(paxOption.length <= 0)
            return


        let formedData = []

        paxOption.forEach( (option) => formedData.push({
            id: option?.id,
            title: option?.title,
            code: option?.code,
            value:0
        }) )


        setData(formedData)

    },[paxOption])


    // modify max value
    useEffect(() => {
        if(paxOption.length <= 0)
            return

        let formedData = []

        paxDetails.forEach( (option) => {
            (option?.value <= maxSize || option?.value === 0)
                ? formedData.push({ ...option})
                : formedData.push({ ...option, value:maxSize })
        })

        setData(formedData)
    }, [maxSize])





    const onPaxChange = e => {
        const id = e?.target?.id
        const title = e?.target?.name
        const data = parseInt(e?.target?.value || 0)
        const value = data > maxSize ? maxSize : data

        let formedData = []

        paxDetails.forEach( (option) => {
            (option?.id !== id)
                ? formedData.push({ ...option})
                : formedData.push({ ...option, id, title, value })
        })

        setData(formedData)
    }

    const setData = data => {
        setPaxDetails(data)
        setExternalData(data)
    }

    return <>
        { loadingPax
            ? <div className={'fex-center'}> <i className={'fa fa-spinner fa-pulse fa-3x fa-fw'} aria-hidden={ true } /> </div>
            : <Row className={'mb-1em'}>
                {
                    paxDetails.map((option, i) => <Col key={`pax-option-${i}`} sm={4}>
                        <FormGroup>
                            <label>{ option?.title }</label>
                            <Input
                                id={ option?.id }
                                name={ option?.title }
                                type='number'
                                min={ 0 }
                                max={ maxSize }
                                value={ option?.value }
                                onChange={ onPaxChange }
                            />
                        </FormGroup>
                    </Col>)
                }
            </Row>
        }
    </>
}

const mapStateToProps = state => ({ formState: state.formProps })
const mapActionsToProps = ({})

export default connect(mapStateToProps, mapActionsToProps)(RestaurantPaxDetails)